<ng-template #termGeneCount let-genecount="geneCount" let-termid="termId">
  <div>{{genecount}} genes are annotated with {{termid}}</div>
  <div class="term-gene-count-link-hint">(click to view)</div>
</ng-template>

<ng-template #showDetailsDisabled>
  <div>All details for this publication cannot be displayed
  simultaneously because of the large number of annotations.</div>
  <div>You can use the "+" buttons to show details for individual
  terms below.</div>
</ng-template>

<div class="sub-table">
  <div *ngIf="!detailsOnly" class="view-controls">
    <a *ngIf="currentViewState != TableViewState.Details && !isLargeTable()" (click)="allDetailsView()">
      Show details ...
    </a>
    <span *ngIf="currentViewState != TableViewState.Details && isLargeTable()"
          class="show-details-disabled"
          [popover]="showDetailsDisabled"
          triggers="mouseenter:mouseleave" placement="bottom" container="body">
      Show details ...
    </span>
    <a *ngIf="currentViewState == TableViewState.Details" (click)="allSummaryView()">Show summary ...</a>
  </div>

  <div class="filter-controls">
    <app-annotation-table-filters *ngIf="filterConfig"
                                  [filterConfig]="filterConfig"
                                  [scope]="scope"
                                  [annotationTable]="annotationTable"
                                  [currentViewState]="currentViewState"
                                  (filterChange)="updateCurrentFilter($event)">
    </app-annotation-table-filters>
  </div>

  <div class="large-table-message" *ngIf="isLargeTable()">
    Note: This section has {{annotationCount}} annotations so page loading may be slow.
    The {{this.typeConfig.feature_type}} list has been truncated for some terms.
  </div>

  <div class="gene-structure-changed-message"
       *ngIf="showStructureChangedMessage()">
    <div *ngFor="let line of typeConfig.gene_structure_change_message">{{line}}</div>
  </div>

  <div *ngIf="geneDetails && typeConfig">
    <app-annotation-table-widgets [annotationTable]="annotationTable"
                                  [annotationTypeName]="annotationTypeName"
                                  [typeConfig]="typeConfig"
                                  [geneDetails]="geneDetails"
                                  [filters]="filters">
    </app-annotation-table-widgets>
  </div>

  <div *ngIf="tableIsFiltered" class="filter-count">
    <span *ngIf="filteredAnnotationCount == annotationCount">
      Showing all annotations
    </span>
    <span *ngIf="filteredAnnotationCount != annotationCount">
      Showing {{filteredAnnotationCount}} of {{annotationCount}} annotations
    </span>
  </div>

  <table>
    <thead>
      <tr *ngIf="currentViewState == TableViewState.Details">
        <th>&nbsp;</th>
        <th *ngIf="showColumn['gene'] && featureInFirstColumn">Gene</th>
        <th *ngIf="showColumn['genotype'] && featureInFirstColumn">Genotype</th>
        <th *ngIf="showColumn['term_id'] && !typeConfig.is_a_fake_ontology">Term ID</th>
        <th *ngIf="typeConfig.is_a_fake_ontology">ID</th>
        <th *ngIf="!typeConfig.is_a_fake_ontology">Term name</th>
        <th *ngIf="typeConfig.is_a_fake_ontology">Name</th>
        <th *ngIf="showColumn['gene'] && !featureInFirstColumn">Gene</th>
        <th *ngIf="showColumn['genotype'] && !featureInFirstColumn">Genotype</th>
        <th *ngIf="showColumn['genotype_background'] && !featureInFirstColumn">Background</th>
        <th *ngIf="showColumn['allele_promoters'] && !featureInFirstColumn">Promoter</th>
        <th *ngIf="showColumn['transcripts']">Transcript ID</th>
        <th *ngIf="showColumn['evidence']">Evidence</th>
        <th *ngIf="showColumn['annotation_phenotype_score']">Phenotype score</th>
        <th *ngIf="showColumn['conditions']">Conditions</th>
        <th *ngIf="showColumn['qualifiers']">Qualifiers</th>
        <th *ngIf="showColumn['term-xref']">Source</th>
        <th *ngIf="showColumn['residue']">Residue</th>
        <th *ngIf="showColumn['reference']">Reference</th>
        <th *ngIf="showColumn['count']">Count</th>
      </tr>
    </thead>

    <tbody *ngFor="let termAnnotation of filteredTable; trackBy:trackByTermId">
      <tr *ngIf="detailsViewVisible(termAnnotation) && (!compactFirstRows[termAnnotation.term.termid] || tableIsFiltered)" class="term-annotation-top">
        <td style="width: 2em" [attr.rowspan]="termAnnotation.annotations.length + 1">
          <a *ngIf="!detailsOnly" (click)="toggleDetails(termAnnotation)">
            <span class="collapse-icon" *ngIf="detailsViewVisible(termAnnotation)">-</span>
            <span class="collapse-icon" *ngIf="!detailsViewVisible(termAnnotation)">+</span>
          </a>
        </td>
        <td *ngIf="featureInFirstColumn">
        </td>
        <td *ngIf="showColumn['term_id']" [attr.rowspan]="termAnnotation.annotations.length + 1">
          <span class="rel-and-termid">
            <span *ngIf="termAnnotation.rel_names && termAnnotation.rel_names.length > 0">
              <span class='rel-icon'>&#8593;</span><span class="rel-name">{{termAnnotation.rel_names}}</span>
            </span>
            <app-term-link [term]="termAnnotation.term" [hideTermIdPrefix]="!!typeConfig.hide_term_id_prefix">
              {{getDisplayTermId(termAnnotation)}}
            </app-term-link>
          </span>
        </td>
        <td [attr.colspan]="termNameColSpan">
          <span *ngIf="termAnnotation.is_not" class="not-annotation">NOT</span>
          <span class="term-name">
            <app-term-link [term]="termAnnotation.term" [hideTermIdPrefix]="!!typeConfig.hide_term_id_prefix">
              {{termAnnotation.term.name}}
            </app-term-link>
          </span>
        </td>
        <td *ngIf="showColumn['count']"
            [attr.rowspan]="termAnnotation.annotations.length + 1">
          <a *ngIf="termAnnotation.term.genotype_count == 0 && !termAnnotation.is_not"
             routerLink="/term/{{termAnnotation.term.termid}}"
             [popover]="termGeneCount"
             triggers="mouseenter:mouseleave"
             placement="bottom" container="body"
             [popoverContext]="getCountPopoverContext(termAnnotation.term)">
            {{termAnnotation.term.gene_count}}
          </a>
        </td>
      </tr>

      <tr class="term-annotation"
          *ngFor="let annotation of detailsViewVisible(termAnnotation) ? termAnnotation.annotations : [] ; let i = index">
        <td  *ngIf="i == 0 && !tableIsFiltered && compactFirstRows[termAnnotation.term.termid]" style="width: 2em"
             [attr.rowspan]="termAnnotation.annotations.length">
          <a *ngIf= "!detailsOnly" (click)="toggleDetails(termAnnotation)">
            <span class="collapse-icon" *ngIf="detailsViewVisible(termAnnotation)">-</span>
            <span class="collapse-icon" *ngIf="!detailsViewVisible(termAnnotation)">+</span>
          </a>
        </td>
        <td *ngIf="showColumn['gene'] && featureInFirstColumn">
          <span *ngFor="let gene of annotation.genes">
            <app-gene-link
              class="app-link" [long]="false" [gene]="gene"></app-gene-link>
              <div *ngIf="!showColumn['transcripts']">
                {{transcriptDisplay(annotation, true)}}
              </div>
          </span>
        </td>
        <td class="genotype-column" *ngIf="showColumn['genotype'] && featureInFirstColumn">
          <app-genotype-link class="app-link" *ngIf="annotation.genotype" [genotype]="annotation.genotype"></app-genotype-link>
          <div class="genotype-background" *ngIf="annotation.genotype_background">
            <span>background:</span> {{annotation.genotype_background}}
          </div>
          <app-allele-promoter-list [annotation]="annotation" [long]="true"></app-allele-promoter-list>
        </td>
        <td *ngIf="showColumn['term_id'] && !tableIsFiltered && compactFirstRows[termAnnotation.term.termid] && i == 0"
            [attr.rowspan]="termAnnotation.annotations.length">
          <span class="rel-and-termid">
            <span *ngIf="termAnnotation.rel_names && termAnnotation.rel_names.length > 0">
              <span class="rel-icon">&#8593;</span><span class="rel-name">{{termAnnotation.rel_names}}</span>
            </span>
            <app-term-link [term]="termAnnotation.term" [hideTermIdPrefix]="!!typeConfig.hide_term_id_prefix">
              {{getDisplayTermId(termAnnotation)}}
            </app-term-link>
          </span>
        </td>
        <td>
          <div *ngIf="showColumn['extension'] && annotation.extension" class="extension">
            <app-extension-display [extension]="annotation.extension"
                                   [annotationTypeName]="annotationTypeName"
                                   [geneShort]="annotation.genes[0]"></app-extension-display>
          </div>
          <div *ngIf="!tableIsFiltered && compactFirstRows[termAnnotation.term.termid] && i == 0">
            <span *ngIf="termAnnotation.is_not" class="not-annotation">NOT</span>
            <app-term-link [term]="termAnnotation.term" [hideTermIdPrefix]="!!typeConfig.hide_term_id_prefix">
              <span class="term-name">{{termAnnotation.term.name}}</span>
            </app-term-link>
          </div>
        </td>
        <td *ngIf="showColumn['genotype'] && !featureInFirstColumn">
          <app-genotype-link class="app-link" *ngIf="annotation.genotype"
                             [genotype]="annotation.genotype"
                             [background]="annotation.genotype_background">
          </app-genotype-link>
          <div class="genotype-background" *ngIf="annotation.genotype_background">
            <span>background:</span> {{annotation.genotype_background}}
          </div>
          <app-allele-promoter-list [annotation]="annotation" [long]="true"></app-allele-promoter-list>
        </td>
        <td *ngIf="showColumn['genotype_background']">
          <span class="genotype-background">
            {{annotation.genotype_background}}
          </span>
        </td>
        <td *ngIf="showColumn['allele_promoters']">
          <span class="allele-promoters">
            <app-allele-promoter-list [annotation]="annotation" [long]="false"></app-allele-promoter-list>
          </span>
        </td>
        <td *ngIf="showColumn['transcripts']">
          {{transcriptDisplay(annotation, false)}}
        </td>
        <td class="with" *ngIf="showColumn['evidence']">
          <app-evidence-link class="app-link" *ngIf="annotation.evidence"
                            [evidence]="annotation.evidence" [assignedBy]="annotation.assigned_by"
                            [assignedDate]="annotation.date">
          </app-evidence-link>
          <span *ngIf="annotation.withs && annotation.withs.length > 0">with
            <span *ngFor="let withVal of annotation.withs; let lastWith = last">
              <app-with-or-from-link [withOrFrom]="withVal"></app-with-or-from-link><span *ngIf="!lastWith">, </span>
            </span>
          </span>
          <span *ngIf="annotation.froms && annotation.froms.length > 0">from
            <span *ngFor="let fromVal of annotation.froms; let lastFrom = last">
              <app-with-or-from-link [withOrFrom]="fromVal"></app-with-or-from-link><span *ngIf="!lastFrom">, </span>
            </span>
          </span>
        </td>
        <td *ngIf="showColumn['annotation_phenotype_score']">
          <div *ngIf="annotation.annotation_phenotype_score">
            {{annotation.annotation_phenotype_score}}
          </div>
        </td>
        <td *ngIf="showColumn['conditions']">
          <ul class="conditions">
          <li *ngFor="let conditionAndDetail of annotation.condition_details">
            <app-term-link [term]="conditionAndDetail[0]">{{conditionAndDetail[0].name}}</app-term-link>
            <span *ngIf="conditionAndDetail[1]">({{conditionAndDetail[1]}})</span>
          </li>
          </ul>
        </td>
        <td *ngIf="showColumn['qualifiers']">
          <div *ngIf="annotation.qualifiers">
            {{annotation.qualifiers}}
          </div>
        </td>
        <td *ngIf="showColumn['term-xref']">
          <div *ngFor="let xrefKV of termAnnotation.term.xrefs | keyvalue">
            <div *ngIf="showXRef(xrefSource(xrefKV), annotation.reference)">
              <a href="{{getTermXrefLink(xrefSource(xrefKV), xrefId(xrefKV), annotation.genes[0].uniquename)}}">{{xrefKV.key}}</a>
            </div>
          </div>
          <div *ngFor="let sourceName of otherSources(annotation.reference)">
            {{sourceName}}
          </div>
        </td>
        <td *ngIf="showColumn['residue']">{{annotation.residue}}</td>
        <td *ngIf="showColumn['reference']">
          <app-reference-short *ngIf="annotation.reference"
                               [reference]="annotation.reference"></app-reference-short>
        </td>
        <td *ngIf="!tableIsFiltered && compactFirstRows[termAnnotation.term.termid] && showColumn['count'] && i == 0"
            [attr.rowspan]="termAnnotation.annotations.length">
          <a *ngIf="typeConfig.feature_type == 'gene' && !termAnnotation.is_not"
             routerLink="/term/{{termAnnotation.term.termid}}"
             [popover]="termGeneCount"
             triggers="mouseenter:mouseleave"
             placement="bottom" container="body"
             [popoverContext]="getCountPopoverContext(termAnnotation.term)">
            {{termAnnotation.term.gene_count}}
          </a>
        </td>
      </tr>

      <tr *ngIf="!detailsViewVisible(termAnnotation) && termAnnotation.summary" class="term-annotation-top">
        <td style="width: 2em">
          <a (click)="toggleDetails(termAnnotation)">
            <span class="collapse-icon" *ngIf="detailsViewVisible(termAnnotation)">-</span>
            <span class="collapse-icon" *ngIf="!detailsViewVisible(termAnnotation)">+</span>
          </a>
        </td>

        <td [attr.colspan]="termNameColSpan">
           <span *ngIf="termAnnotation.is_not" class="not-annotation">NOT</span>
            <app-term-link [term]="termAnnotation.term" [hideTermIdPrefix]="!!typeConfig.hide_term_id_prefix">
              <span class="term-name">
                {{termAnnotation.term.name}}
              </span>
            </app-term-link>
        </td>
      </tr>

      <tr class="summary-row" *ngFor="let row of detailsViewVisible(termAnnotation) || !termAnnotation.summary ? [] : termAnnotation.summary; let idx = index">
        <td>
        </td>
        <td class="summary-feature" colspan="6">
          <span *ngIf="row.genes && row.genes.length > 0">
            <span *ngFor="let gene of getSummaryRowGenes(termAnnotation, idx); let lastGene = last">
              <app-gene-link class="app-link" [long]="false" [gene]="gene"></app-gene-link><span *ngIf="!lastGene">, </span>
            </span>
          </span>
          <span *ngIf="row.genotypes && row.genotypes.length > 0">
            <span *ngFor="let genotype of getSummaryRowGenotypes(termAnnotation, idx); let lastGenotype = last">
              <app-genotype-link class="app-link" [genotype]="genotype"></app-genotype-link><span *ngIf="!lastGenotype">, &nbsp;</span>
            </span>
          </span>
          <div *ngIf="!allOfSummaryRowVisible(termAnnotation, idx)" class="show-all-summary-row">
            <a (click)="showAllOfSummaryRow(termAnnotation, idx)">{{showAllSummaryRowLinkText(termAnnotation, idx)}}</a>
          </div>
          <app-extension-display *ngIf="row.extension" [extension]="row.extension"
                                 [annotationTypeName]="annotationTypeName"
                                 [geneShort]="row.genes[0] || geneDetails"></app-extension-display
>
        </td>
      </tr>

    </tbody>

  </table>

  <span class="no-annotations" *ngIf="filteredTable.length == 0">
    (No annotations after filtering)
  </span>

  <div class="annotation-table-ext-links" *ngIf="externalLinksConfig.length != 0">
    <app-annotation-table-ext-links [termIds]="allTermIds" [extLinksConfig]="externalLinksConfig">
    </app-annotation-table-ext-links>
  </div>
</div>
